const createFilter = (filterId, filterType, value = [], label = null) => ({
    filter_id: filterId,
    value,
    type: filterType,
    include: true,
    label,
  });

export default createFilter;
